import { Typography } from '@mui/material';
import { FC, useEffect } from 'react';

import { useFullUser } from '../../../hooks/auth/use-user';
import { useDashboardBalance } from '../../../hooks/use-dashboard-balance';
import { getCurrencyShortHand } from '../../../lib/get-currency-short-hand';
import { isDefined } from '../../../utils/utils';
import { Flex } from '../../v2/common/Flex';

import styles from './Balance.module.scss';

export type BalanceProps = {};

export const Balance: FC<BalanceProps> = () => {
  const { merchantInfo } = useFullUser();
  const { getBalance, balance } = useDashboardBalance();

  useEffect(() => {
    if (!merchantInfo?.merchant_id) {
      return;
    }

    getBalance();
  }, [getBalance, merchantInfo?.merchant_id]);

  return (
    <Flex className={styles.root} gap={4}>
      <Typography
        sx={{
          fontSize: '1.25rem',
          fontWeight: '700',
        }}
      >
        Balance
      </Typography>

      {balance?.filter(isDefined).map(({ currency_id, balance }) => {
        return (
          <Typography
            key={currency_id}
            sx={{
              fontSize: '1.25rem',
              fontWeight: '700',
            }}
            component="span"
            color="primary"
          >
            {getCurrencyShortHand(currency_id)} {balance}
          </Typography>
        );
      })}
    </Flex>
  );
};
